
import IconRefresh from '@svg/IconRefresh.svg'
import IconThumbDown from '@svg/IconThumbDown.svg'
import IconThumbUp from '@svg/IconThumbUp.svg'
import { Component, Prop, Vue } from 'vue-property-decorator'

export type FeedbackRating = 0 | 1

@Component({
  components: {
    IconRefresh,
    IconThumbDown,
    IconThumbUp,
  },
})
export default class GenerateJigFeedbackActions extends Vue {
  // null until the user has submitted a feedback for this generation. After
  // submission the thumbs disable and the matching button stays highlighted.
  @Prop({ type: Number, default: null })
  public submittedRating!: FeedbackRating | null

  private get isSubmitted(): boolean {
    return this.submittedRating === 0 || this.submittedRating === 1
  }

  private get thumbsUpLabel(): string {
    return this.submittedRating === 1 ? 'Feedback submitted: thumbs up' : 'Thumbs up'
  }

  private get thumbsDownLabel(): string {
    return this.submittedRating === 0 ? 'Feedback submitted: thumbs down' : 'Thumbs down'
  }

  private onFeedbackClick(rating: FeedbackRating) {
    if (this.isSubmitted) {
      return
    }
    this.$emit('feedback', rating)
  }

  private onRefreshClick() {
    this.$emit('refresh')
  }
}
